import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack, Typography } from '@mui/material';
import { addMonths, subMonths } from 'date-fns';
import format from 'date-fns/format';
import { ChevronLeft, ChevronRight } from 'mdi-material-ui';
const MonthFilter = ({ month, setMonth }) => {
    return (_jsxs(Stack, Object.assign({ direction: "row", alignItems: "center", gap: 3 }, { children: [_jsx(ChevronLeft, { sx: {
                    color: '#71797A',
                    fontSize: '20px',
                    cursor: 'pointer'
                }, onClick: () => setMonth(subMonths(month, 1)) }), _jsx(Box, Object.assign({ display: "flex", justifyContent: "center", sx: { width: '160px' } }, { children: _jsx(Typography, Object.assign({ variant: "h2", fontWeight: "fontWeightSemiBold" }, { children: format(month, 'MMMM yyyy') })) })), _jsx(ChevronRight, { sx: {
                    color: '#71797A',
                    fontSize: '20px',
                    cursor: 'pointer'
                }, onClick: () => setMonth(addMonths(month, 1)) })] })));
};
export default MonthFilter;
